import { OntologyTypeConfigs } from 'store/utils/knowledgeGraphIcons';
import LinkIcon from '@mui/icons-material/LinkRounded';
import styles from 'components/knowledgeGraph/components/nodes/NodeChild.module.scss';

// Helper function to get the icon component based on ontology type
export const getIconComponent = type => {
  return OntologyTypeConfigs[type]?.componentIcon || OntologyTypeConfigs['meta:KB_Class'].componentIcon;
};

const NodeChild = ({ child, onMouseEnter, onClick }) => {
  // Use the ontology type to get the correct icon & color
  const childOntologyType = OntologyTypeConfigs[child.ontologyType] ? child.ontologyType : 'none';
  const ChildIconComponent = getIconComponent(childOntologyType);
  const ontologyColor = OntologyTypeConfigs[childOntologyType]?.color || 'inherit';

  const handleMouseEnter = e => {
    onMouseEnter(child, e);
  };

  const handleOnClick = e => {
    onClick(child, e);
  };

  return (
    <div
      data-child-node-id={child.id}
      className={styles.childItem}
      onMouseEnter={handleMouseEnter}
      onClick={handleOnClick}
    >
      {/* Icon for the child node */}
      {ChildIconComponent && <ChildIconComponent className={styles.childIcon} style={{ color: ontologyColor }} />}

      <span style={{ color: ontologyColor }}>{child.name}</span>

      {/* Conditionally show a 'link' icon if this child is a foreign key or relationship */}
      {child.isRelationship && <LinkIcon className={styles.linkIcon} />}
    </div>
  );
};

export default NodeChild;
